import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate } from '../../utils/util';
import { ENUMS } from '../../utils/constants';
import PhysicalConfirmationService from '../../services/PhysicalConfirmationService';
import SelectNew from './SelectNew';

const SelectPrintTypeUI = (props) => {
    const onChange = (evt) => {
        props.setPrintSelect(evt.target.value)
        if (props.onChange) {
            props.onChange(evt);
        }
    }

    return (
        <SelectNew
            required={props.required}
            id={props.id || 'print'}
            name={props.id || 'print'}
            display="name"
            label={translate('print-type', 'physical-confirmation')}
            placeHolder={translate('choose-one-option', 'general')}
            data={[
                { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
            ]}
            change={onChange}
            value={props.value}
        />)
}

const mapStateToProps = () => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectPrintTypeUI));
